import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../../shared/shared.module";
import { EventContainerComponent } from "./event-container.component";
import { EventListComponent } from "./event-list/event-list.component";
import { PaginatorComponent } from "./event-list/paginator/paginator.component";
import { EventComponent } from "./event/event.component";
import { TrafficActionListComponent } from "./event/traffic-action-list/traffic-action-list.component";
import { AnnouncementListItemComponent } from "./traffic-action/announcement-list/announcement-list-item/announcement-list-item.component";
import { AnnouncementListComponent } from "./traffic-action/announcement-list/announcement-list.component";
import { TrafficActionComponent } from "./traffic-action/traffic-action.component";
import { AnnouncementComponent } from "./announcement/announcement.component";
import { AnnouncementTextComponent } from "./announcement/announcement-text/announcement-text.component";

const exportedDeclarations = [
  EventContainerComponent,
  EventListComponent,
  TrafficActionListComponent,
  PaginatorComponent,
  AnnouncementListComponent,
  AnnouncementListItemComponent,
  EventComponent,
  TrafficActionComponent,
  AnnouncementComponent,
  AnnouncementTextComponent,
];
@NgModule({
  declarations: exportedDeclarations,
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: exportedDeclarations,
})
export class EventModule {}
